import React from 'react';

const ArrowDownIcon = function ArrowDownIcon() {
  return (
    <svg width="16" height="17" className="arrow-down-icon" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.1931 9.61254C15.413 9.43273 15.5104 9.14652 15.4446 8.87327C15.3789 8.60002 15.1613 8.38667 14.8827 8.3222C14.6041 8.25774 14.3123 8.35322 14.1289 8.56884L8.69291 13.8938L8.69291 1.28138C8.67156 0.886824 8.33913 0.577637 7.93625 0.577637C7.53337 0.577637 7.20094 0.886824 7.17959 1.28138L7.17959 13.8938L1.74996 8.56049C1.45219 8.28163 0.983503 8.28163 0.68574 8.56049C0.544326 8.69874 0.464844 8.88651 0.464844 9.08234C0.464844 9.27816 0.544326 9.46593 0.68574 9.60419L7.41159 16.2004C7.55082 16.3422 7.74294 16.4224 7.9437 16.4224C8.14447 16.4224 8.33658 16.3422 8.47581 16.2004L15.1931 9.61254Z" fill="#1EC252" />
    </svg>
  );
};

export default ArrowDownIcon;
